let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("66fD9")).then(() => parcelRequire('oWc1A'));